module.exports = __webpack_public_path__ + "img/hero-shape-19.c3269ff0.png";